import * as angular from "angular";

export class SidebarController {
    
    /* @ngInject */
    constructor(private $location:angular.ILocationService) {}

    isActivePath(path:string) {
        return this.$location.path() === path;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/sidebar/sidebar.controller.ts